import { render } from "./AuditLogViewer.vue?vue&type=template&id=2775f856&scoped=true"
import script from "./AuditLogViewer.vue?vue&type=script&lang=js"
export * from "./AuditLogViewer.vue?vue&type=script&lang=js"

import "./AuditLogViewer.vue?vue&type=style&index=0&id=2775f856&lang=css"
import "./AuditLogViewer.vue?vue&type=style&index=1&id=2775f856&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2775f856"]])

export default __exports__